import mixpanel from "mixpanel-browser";

import { BannerMixpanelHandlers } from "./bannerMixpanelHandlers";
import { BillingNoteMixpanelHandlers } from "./billingNoteMixpanelHandlers";
import { CombinedPaymentNoteMixpanelHandlers } from "./combinedPaymentNoteMixpanelHandlers";
import { CreateMerchantMixpanelHandlers } from "./createMerchantMixpanelHandlers";
import { CreditNoteMixpanelHandlers } from "./creditNoteMixpanelHandlers";
import { DashboardMixpanelHandlers } from "./dashboardMixpanelHandlers";
import { DebitNoteMixpanelHandlers } from "./debitNoteMixpanelHandler";
import { ExpensesMixpanelHandlers } from "./expensesMixpanelHandlers";
import { HelpMenuMixpanelHandlers } from "./helpMenuMixpanelHandlers";
import { InAppMixpanelHandlers } from "./inAppMixpanelHandlers";
import { InvoiceMixpanelHandlers } from "./invoiceMixpanelHandlers";
import { PurchaseAssetMixpanelHandlers } from "./purchaseAssetMixpanelHandlers";
import { PurchaseInventoryRecordMixpanelHandlers } from "./purchaseInventoryRecordMixpanelHandlers";
import { PurchaseOrderMixpanelHandlers } from "./purchaseOrderMixpanelHandlers";
import { PurchaseTaxInvoiceMixpanelHandlers } from "./purchaseTaxInvoiceMixpanelHandlers";
import { QuotationMixpanelHandlers } from "./quotationMixpanelHandlers";
import { ReceiptMixpanelHandlers } from "./receiptMixpanelHandlers";
import { ReceiveCreditNoteMixpanelHandlers } from "./receiveCreditNoteMixpanelHandlers";
import { ReceiveDebitNoteMixpanelHandlers } from "./receiveDebitNoteMixpanelHandlers";
import { RevenueMixpanelHandlers } from "./revenueMixpanelHandlers";
import { SalesTaxInvoiceMixpanelHandlers } from "./salesTaxInvoiceMixpanelHandlers";
import { UserAuthenticationMixpanelHandlers } from "./userAuthenticatnioMixpanelHandlers";
import { UserRegistrationMixpanelHandlers } from "./userRegistrationMixpanelHandlers";

export class Mixpanel {
  static start() {
    if (process.env.VUE_APP_MixpanelEnabled != "true") return;

    mixpanel.init(process.env.VUE_APP_MixpanelProjectToken, {
      api_method: "POST",
      api_transport: "XHR",
      batch_requests: true,
      batch_size: Number(process.env.VUE_APP_MixpanelConfigBatchSize),
      batch_flush_interval_ms: Number(process.env.VUE_APP_MixpanelConfigBatchFlushIntervalMS),
      batch_request_timeout_ms: Number(process.env.VUE_APP_MixpanelConfigBatchRequestTimeoutMS),
      cookie_domain: "",
      cookie_expiration: Number(process.env.VUE_APP_MixpanelConfigCookieExpiration),
      cross_site_cookie: false,
      cross_subdomain_cookie: true,
      debug: Boolean(process.env.VUE_APP_MixpanelConfigDebugMode == "true"),
      disable_persistence: false,
      ip: Boolean(process.env.VUE_APP_MixpanelConfigCollectLocation == "true"),
      opt_out_tracking_by_default: false,
      opt_out_persistence_by_default: false,
      opt_out_tracking_persistence_type: "localStorage",
      opt_out_tracking_cookie_prefix: undefined,
      persistence: "cookie",
      persistence_name: "",
      property_blacklist: [],
      secure_cookie: true,
      track_links_timeout: 300,
      upgrade: false,
      xhr_headers: {},
      ignore_dnt: false,
    });

    UserAuthenticationMixpanelHandlers.handleAll();
    UserRegistrationMixpanelHandlers.handleAll();
    DashboardMixpanelHandlers.handleAll();
    RevenueMixpanelHandlers.handleAll();
    QuotationMixpanelHandlers.handleAll();
    InvoiceMixpanelHandlers.handleAll();
    ReceiptMixpanelHandlers.handleAll();
    SalesTaxInvoiceMixpanelHandlers.handleAll();
    CreditNoteMixpanelHandlers.handleAll();
    DebitNoteMixpanelHandlers.handleAll();
    BillingNoteMixpanelHandlers.handleAll();
    ExpensesMixpanelHandlers.handleAll();
    PurchaseOrderMixpanelHandlers.handleAll();
    PurchaseInventoryRecordMixpanelHandlers.handleAll();
    PurchaseAssetMixpanelHandlers.handleAll();
    PurchaseTaxInvoiceMixpanelHandlers.handleAll();
    ReceiveCreditNoteMixpanelHandlers.handleAll();
    ReceiveDebitNoteMixpanelHandlers.handleAll();
    CombinedPaymentNoteMixpanelHandlers.handleAll();
    HelpMenuMixpanelHandlers.handleAll();
    InAppMixpanelHandlers.handleAll();
    BannerMixpanelHandlers.handleAll();
    CreateMerchantMixpanelHandlers.handleAll();
  }
}

export const prop = Object.freeze({
  languages: Object.freeze({
    th: "Thai",
    en: "English",
  }),
  loginSources: Object.freeze({
    0: "Email",
    1: "Google",
  }),
});
